import { Component, JSX, Prop, Watch, h } from '@stencil/core'
import { Loader } from '@googlemaps/js-api-loader'

import { windowProvider } from '../../utils/windowProvider'

@Component({
  tag: 'air-map',
  styleUrl: 'air-map.scss',
  shadow: true,
})
export class AirMap {
  /** Specifies canter of the map */
  @Prop() center!: google.maps.LatLng | google.maps.LatLngLiteral
  @Watch('center')
  watchCenterChange(newCenter: google.maps.LatLng | google.maps.LatLngLiteral): void {
    this.setCenter(newCenter)
  }

  /** Specifies map options */
  @Prop() options?: google.maps.MapOptions

  /** Specifies map zoom */
  @Prop() zoom = 15

  private map!: google.maps.Map
  private mapElement?: HTMLDivElement
  private marker!: google.maps.Marker
  private googleMapsApiLoader?: Loader

  async componentDidLoad(): Promise<void> {
    await this.initMap()
  }

  private async initMap(): Promise<void> {
    const { googleMapsApiKey } = windowProvider().AirConfig

    if (googleMapsApiKey === undefined) {
      throw new Error('Please provide a Google Map API key')
    }

    this.googleMapsApiLoader = new Loader({
      apiKey: googleMapsApiKey,
      version: 'weekly',
      libraries: ['places'],
    })
    const options = {
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: false,
      zoom: this.zoom,
      ...this.options,
    }

    const google = await this.googleMapsApiLoader.load()
    this.map = new google.maps.Map(this.mapElement as HTMLElement, options)
    this.marker = new google.maps.Marker({
      map: this.map,
      anchorPoint: new google.maps.Point(0, -29),
    })
    this.setCenter(this.center)
  }

  private setCenter(center: google.maps.LatLng | google.maps.LatLngLiteral): void {
    this.map.setCenter(center)
    this.marker.setVisible(false)
    this.marker.setPosition(center)
    this.marker.setVisible(true)
  }

  render(): JSX.Element {
    return (
      <div
        class="map"
        ref={(el?: HTMLDivElement): void => {
          this.mapElement = el
        }}
      ></div>
    )
  }
}
